import React from "react";
import { InputNumber } from "antd";
import { getAdvancedFieldsForScenario } from "../../config";

const inputStyle = { width: "100%", borderRadius: 6, height: 44 };
const formatAmount = (value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
const parseAmount = (value) => value.replace(/\$\s?|(,*)/g, "");

export default function AdvancedLoanFields({
  lienPosition,
  open,
  onToggle,
  appraisedValue,
  totalLoanAmount,
  secondaryLoanAmount,
  cltv,
  hcltv,
  onAppraisedValueChange,
  onTotalLoanAmountChange,
  onSecondaryLoanAmountChange,
  onCltvChange,
  onHcltvChange,
}) {
  const availableFields = getAdvancedFieldsForScenario({
    lienPosition,
    advancedOpen: true,
  });
  const visibleFields = getAdvancedFieldsForScenario({
    lienPosition,
    advancedOpen: open,
  });
  if (availableFields.length === 0) return null;

  const amountField = (field, label, value, onChange, helpText) => (
    visibleFields.includes(field) && (
      <div className="search-fields-content-item-content-item" data-advanced-field={field}>
        <div className="search-fields-content-item-content-item-title">{label}</div>
        {helpText && (
          <div style={{ color: "#586570", fontSize: "12px", lineHeight: "18px", marginBottom: "4px" }}>
            {helpText}
          </div>
        )}
        <InputNumber
          prefix="$"
          style={inputStyle}
          value={value}
          onChange={onChange}
          formatter={formatAmount}
          parser={parseAmount}
        />
      </div>
    )
  );
  const ratioField = (field, label, value, onChange) => (
    visibleFields.includes(field) && (
      <div className="search-fields-content-item-content-item" data-advanced-field={field}>
        <div className="search-fields-content-item-content-item-title">{label}</div>
        <InputNumber suffix="%" style={inputStyle} value={value} onChange={onChange} />
      </div>
    )
  );

  return (
    <>
      <div
        role="button"
        tabIndex={0}
        data-testid="ppe-advanced-toggle"
        onClick={onToggle}
        onKeyDown={(event) => {
          if (event.key === "Enter" || event.key === " ") onToggle();
        }}
        style={{ color: "#325CEB", cursor: "pointer", fontWeight: 500, margin: "10px 0" }}
      >
        {open ? "− " : "+ "}Advanced &amp; fee overrides
      </div>
      {amountField("appraisedValue", "Appraised value", appraisedValue, onAppraisedValueChange)}
      {amountField("totalLoanAmount", "Total loan", totalLoanAmount, onTotalLoanAmountChange)}
      {amountField(
        "secondaryLoanAmount",
        "Subordinate loan balance",
        secondaryLoanAmount,
        onSecondaryLoanAmountChange,
        "Use for a closed-end subordinate mortgage balance. For HELOC, select Second lien + HELOC and enter Line amount and Draw.",
      )}
      {ratioField("cltv", "CLTV", cltv, onCltvChange)}
      {ratioField("hcltv", "HCLTV", hcltv, onHcltvChange)}
    </>
  );
}
